import styled from 'styled-components';
export const Placeholder = styled.div.attrs({ 'aria-hidden': true }) `
    background-color: #e5e5e5;
    color: #e5e5e5;
    text-align: center;
    animation: placeholderBlinks 1s infinite;
`;
//# sourceMappingURL=Placeholder.js.map